export enum UserPrefabricatedClaimType {
    AmbergClaims = "AmbergClaims",
    PartnerOrSubsidiaryClaims = "PartnerOrSubsidiaryClaims",
    RemoveClaims = "RemoveClaims"
}